import React, { useContext, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import WalletConnect from './WalletConnect';
import { Offcanvas, Dropdown } from "react-bootstrap";
import SidebarAdmin from "../Components/SidebarAdmin";
import { AdminContext } from '../Context/AdminContext';
import NotificationDropdownAdmin from './NotificationDropdownAdmin';
import { AuthApi } from '../utils/api';
import { useEffect } from 'react';
import ThemeToggle from './ThemeToggle';
import LanguageToggle from './LanguageToggle';
import { FaSignOutAlt } from 'react-icons/fa';
import { useTranslation } from '../Context/LanguageContext';

const Header = (props) => {
    const { logoutHandle } = props;
    const [show, setShow] = useState(false);
    const { admin } = useContext(AdminContext);
    const { name, role } = admin?.admin || {};
    const [unreadNotificationCount, setUnreadNetnotificationCount] = useState(0);
    const [notificationList, setNotificationList] = useState([]);
    const { t } = useTranslation();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const notificationCountRef = useRef(0);

    const getNotifications = async () => {
        try {
            const notificationResponse = await AuthApi.get(`/admin/get-notifications`);;
            const { status, data } = notificationResponse;
            if (status === 200) {
                if (data.notifications !== undefined) {
                    setNotificationList(data.notifications);
                    setUnreadNetnotificationCount(data.notifications.length);
                }
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    }

    function onNotificationReceived(payload) {
        const data = payload.notification;
        const notificationTitle = data.title;
        const notificationOptions = {
            body: data.body
        };

        if (!('Notification' in window)) {
            console.log("Browser does not support system notification");
        } else if (Notification.permission === "granted") {
            const notif = new Notification(notificationTitle, notificationOptions);
        }

        notificationCountRef.current = notificationCountRef.current + 1;
        setUnreadNetnotificationCount(notificationCountRef.current);
    }

    useEffect(() => {
        getNotifications();
    }, [unreadNotificationCount]);

    return (
        <>
            <nav
                className='dashboard-header navbar navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl'
                id='navbarBlur'
                navbar-scroll='true'
            >
                <div className='container-fluid py-1 px-3'>
                    <nav aria-label='breadcrumb'>
                        <ol className='breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5'>
                            <li className='breadcrumb-item text-sm'>
                                <Link className='opacity-5' style={{ color: 'var(--text-muted)' }} to='/admin-dashboard'>
                                    {t('pages')}
                                </Link>
                            </li>
                            <li
                                className='breadcrumb-item text-sm active'
                                style={{ color: 'var(--text-primary)' }}
                                aria-current='page'
                            >
                                {t('dashboard')}
                            </li>
                        </ol>
                        <h6 className='font-weight-bolder mb-0' style={{ color: 'var(--text-primary)' }}>{t('dashboard')}</h6>
                    </nav>

                    <div
                        className='collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4'
                        id='navbar'
                    >
                        <div className='ms-md-auto pe-md-3 d-flex align-items-center'>
                            {/* Input placeholder if needed */}
                        </div>
                        <ul className='navbar-nav  justify-content-end'>
                            <li className='nav-item d-flex align-items-center me-2'>
                                <LanguageToggle />
                            </li>
                            <li className='nav-item d-flex align-items-center me-2'>
                                <ThemeToggle />
                            </li>
                            <li className='nav-item dropdown pe-0 pe-md-2 d-flex align-items-center me-0 me-md-1'>
                                <Dropdown>
                                    <Dropdown.Toggle variant="primary" id="dropdown-basic" className="mb-0 noti-icon bg-transparent border-0 shadow-none py-1" style={{ color: 'var(--text-primary)' }}>
                                        <i className="fa fa-bell cursor-pointer"></i>
                                        <span className="badge badge-md badge-circle badge-floating badge-danger border-white bg-dark d-block">{unreadNotificationCount}</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="mt-2">
                                        <NotificationDropdownAdmin 
                                            notificationList={notificationList}
                                        />
                                    </Dropdown.Menu>
                                </Dropdown>
                            </li>
                            <li className='nav-item d-flex align-items-center'>
                                <WalletConnect />
                            </li>

                            <li className='nav-item px-3 d-flex align-items-center'>
                                <div className='user-profile-pill no-arrow cursor-default'>
                                    <div className='user-info d-flex flex-column'>
                                        <span className='user-name'>
                                            {name ? name.split(' ')[0] : 'Admin'}
                                        </span>
                                        <span className='user-role'>{role?.role || 'Admin'}</span>
                                    </div>
                                </div>
                            </li>
                            <li className='nav-item d-flex align-items-center'>
                                <button
                                    onClick={logoutHandle}
                                    className='btn btn-link p-0 m-0'
                                    style={{ color: 'var(--text-primary)' }}
                                    title='Sign Out'
                                >
                                    <FaSignOutAlt size={20} />
                                </button>
                            </li>

                            <li className='nav-item d-xl-none ps-3 d-flex align-items-center'>
                                <a
                                    href='javascript:;'
                                    className='nav-link p-0'
                                    style={{ color: 'var(--text-primary)' }}
                                    id='iconNavbarSidenav'
                                    onClick={handleShow}
                                >
                                    <div className='sidenav-toggler-inner'>
                                        <i className='sidenav-toggler-line' style={{ backgroundColor: 'var(--text-primary)' }}></i>
                                        <i className='sidenav-toggler-line' style={{ backgroundColor: 'var(--text-primary)' }}></i>
                                        <i className='sidenav-toggler-line' style={{ backgroundColor: 'var(--text-primary)' }}></i>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <Offcanvas show={show} onHide={handleClose} className='mobilesidebar'>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <div className='d-flex align-items-center'>
                            <div className='text-capitalize' style={{ color: 'var(--text-primary)' }}>
                                <i className='fa fa-user me-sm-1 me-2'></i>{' '}
                                {name ? name.split(' ')[0] : ''} {`( ${role?.role || 'Admin'} )`}
                            </div>
                        </div>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <SidebarAdmin logoutHandle={logoutHandle} />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Header